<template>
  <div class="emoji-picker" v-if="emojis.length > 0">
    <div
      v-for="(emojiGroup, index) in groupEmojisByPoints"
      :key="index"
      class="emoji-point-group-wrapper"
      :class="{ locked: !emojiGroup[0]['unlocked'] }"
    >
      <h3>
        <span
          class="point-unlock-count"
          v-html="
            $t('adaptive-test-battle.point-unlock-status', {
              interpolation: { escapeValue: false },
              pointCount:
                '<strong>' + emojiGroup[0]['point_unlock'] + '</strong>',
            })
          "
        ></span>

        <FaIcon
          :icon="emojiGroup[0]['unlocked'] ? 'lock-open-alt' : 'lock-alt'"
        />
      </h3>

      <ul class="emoji-point-group">
        <li
          v-for="emoji in emojiGroup"
          :key="emoji['id']"
          class="emoji-option"
          @click="onEmojiChange(emoji)"
          role="button"
        >
          <PublicUserEmoji :emoji="emoji['value']"></PublicUserEmoji>
        </li>
      </ul>
    </div>
  </div>
  <LoadingOverlay v-else />
</template>

<script>
import FaIcon from '../../ui/FaIcon'
import PublicUserEmoji from '../username-display/PublicUserEmoji'
import LoadingOverlay from '../../LoadingOverlay'

import UserApi from '../../../apis/user'

export default {
  name: 'EmojiPicker',
  components: { LoadingOverlay, PublicUserEmoji, FaIcon },
  data() {
    return {
      emojis: [],
      emojisByPointsGroup: [],
      chosenEmoji: { id: 0, value: 0 },
    }
  },
  mounted() {
    this.getEmojis()
  },
  computed: {
    /**
     * @private
     */
    groupEmojisByPoints() {
      let groupedEmojiArrayIndex = 0
      let currentPointGroup = 0
      let groupedEmojisArray = [new Array()]

      this.emojis.forEach(emojiData => {
        const pointsUnlockValue = parseInt(emojiData['point_unlock'])

        if (currentPointGroup !== pointsUnlockValue) {
          groupedEmojisArray.push(new Array())
          groupedEmojiArrayIndex++
          currentPointGroup = pointsUnlockValue
        }

        groupedEmojisArray[groupedEmojiArrayIndex].push(emojiData)
      })

      return groupedEmojisArray
    },
  },
  methods: {
    /**
     * @private
     */
    getEmojis() {
      if (this.emojis.length > 0) {
        return
      }

      this.isLoading = true

      new UserApi().getUsernameEmojis().then(emojis => {
        this.emojis = emojis
        this.isLoading = false
      })
    },
    onEmojiChange(emoji) {
      this.chosenEmoji = emoji
      this.$emit('change', emoji)
    },
  },
}
</script>

<style lang="scss" scoped>
h3 > .fa-icon {
  font-size: 1.5em;
  margin-left: 0.3em;
}

.emoji-point-group-wrapper {
  margin-bottom: 1.5em;
  padding-top: 1em;

  &:not(.locked) {
    border: 0.1em solid $grayLighter;
    border-left: none;
    border-right: none;
  }

  &.locked {
    background-color: $grayLighter;
  }
}

.emoji-point-group {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  grid-gap: 1.5em;
  padding: 1em;

  .emoji-option {
    display: inline-block;
    padding: 0;
    background-image: none;
    text-align: center;

    .emoji {
      --emoji-border-color: #{$grayLighter};
      --emoji-background-color: #{$offWhite};
      font-size: 2em;
      padding: 0;
      transition: all 0.2s ease-in-out;
    }

    &:hover .emoji {
      --emoji-border-color: #{$gray};
      --emoji-background-color: #{$grayLight};
    }
  }

  @media screen and (max-width: $popupBreakpoint) {
    grid-template-columns: repeat(auto-fill, minmax(3rem, 1fr));
  }
}
</style>
